/**
 * Section: Newsletter Modal
 * ------------------------------------------------------------------------------
 * Newsletter modal configuration for complete theme support.
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections
 *
 * @namespace newsletterModal
 */
import { register } from '@shopify/theme-sections';
import Cookies from 'js-cookie';
import cssClasses from '~/helpers/cssClasses';
import Modal from '~/components/modal';
/**
 * Register the `newsletter-modal` section type.
 * Executes on page load as well as Theme Editor `section:load` events.
 */

register('newsletter-modal', {
  /**
   * Initialize section objects.
   */
  init() {
    this.settings = {
      id: 'newsletter-modal',
      namespace: 'newsletter_modal'
    };
    this.eventSelectors = {
      modalClose: "Modal:Close:".concat(this.settings.id)
    };
    this.modal = Modal({
      id: this.settings.id
    });
  },

  /**
   * Set event listeners on component.
   */
  setEventBusListeners() {
    Frame.EventBus.listen(this.eventSelectors.modalClose, () => this.handleCloseEvents());
  },

  /**
   * Handle close callback function by setting cookie.
   */
  handleCloseEvents() {
    Cookies.set(this.settings.namespace, 'dismissed', {
      expires: 365
    });
  },

  /**
   * Check if a Cypress test is being run.
   * @returns {Boolean}
   */
  isTestCondition() {
    if (window.Cypress) {
      this.handleCloseEvents();
      return true;
    }

    return false;
  },

  /**
   * Get all modal elements currently on the DOM.
   * @returns {Array}
   */
  getAllActiveModals() {
    return Array.from(document.querySelectorAll(".modal.".concat(cssClasses.active)));
  },

  /**
   * Callback function when section is loaded via the `sections.load()`
   * function or by Theme Editor `shopify:section:unload` event.
   */
  onLoad() {
    if (window.Shopify.enableNewsletterModal === false) {
      return;
    }

    this.init();
    this.setEventBusListeners();
    this.modal.init();
    /**
     * Set conditions on when to show the modal.
     */

    if (!Cookies.get(this.settings.namespace) && !this.isTestCondition()) {
      window.setTimeout(() => {
        if (this.getAllActiveModals().length !== 0) {
          return;
        }

        this.modal.show(this.settings.id);
      }, 10000);
    }
  },

  /**
   * Callback function when section is unloaded by the
   * Theme Editor `shopify:section:unload` event.
   */
  onUnload() {
    this.modal.close(this.settings.id);
  },

  /**
   * Callback function when section is selected by the
   * Theme Editor `shopify:section:select` event.
   */
  onSelect() {
    this.modal.show(this.settings.id);
  },

  /**
   * Callback function when section is deselected by the
   * Theme Editor `shopify:section:deselect` event.
   */
  onDeselect() {
    this.modal.close();
  }

});